import Image, { ImageProps, StaticImageData } from "next/image";
import { CubeMask } from "./components/CubeMask";
import DefaultProfileImg from "/public/images/profile/default_profile.jpeg";

type UserAvatarProps = Omit<ImageProps, "src" | "alt"> & {
  containerClassName?: string;
  src?: string | StaticImageData;
  alt?: string;
};

export function UserAvatar({
  containerClassName,
  src = DefaultProfileImg,
  alt = "User Profile image",
  ...props
}: UserAvatarProps) {
  const image = <Image src={src} alt={alt} draggable={false} {...props} />;
  return <CubeMask className={containerClassName}>{image}</CubeMask>;
}
